import { apiClient } from '../../config/axios-client'
import type { ImageProvider } from '../../shared/models/ImageProvider'

export const imageProvidersApi = {
  list: () => apiClient.get<ImageProvider[]>('imageproviders'),
}
